module.exports = __webpack_public_path__ + "static/pexels-1-4ea879fb5ce62cb5b7b73bf43edeb2f7.png";